import React from 'react';
import { Box } from '@mui/material';
import { BANK_PROVIDERS } from '../../utils/bankingSchema';
import garantiLogo from '../../assets/banks/garanti-bbva.png';
import vakifbankLogo from '../../assets/banks/vakifbank.png';

const LOGO_RADIUS = 10;

const BANK_LOGO_META = {
  [BANK_PROVIDERS.VAKIFBANK]: {
    badge: 'VB',
    label: 'VakıfBank',
    assetSrc: vakifbankLogo,
    bg: 'linear-gradient(145deg, #f59e0b 0%, #d97706 100%)',
    frameBg: '#f59e0b',
    color: '#fff',
    objectPosition: 'center center',
  },
  [BANK_PROVIDERS.GARANTI]: {
    badge: 'GB',
    label: 'Garanti BBVA',
    assetSrc: garantiLogo,
    bg: 'linear-gradient(145deg, #16a34a 0%, #15803d 100%)',
    frameBg: '#ffffff',
    color: '#fff',
    objectPosition: '14% center',
  },
};

/** Tüm bankalar aynı dikdörtgen oran (yaklaşık 2:1). */
const SIZE_MAP = {
  xs: { height: 24, width: 56 },
  sm: { height: 30, width: 72 },
  md: { height: 36, width: 88 },
  lg: { height: 42, width: 104 },
  card: { height: 52, width: 104 },
  xl: { height: 60, width: 120 },
};

const resolveBankKey = (bank, bankLogoKey) => {
  const raw = String(bankLogoKey || bank || '').trim().toLowerCase();
  if (!raw) return '';
  if (raw.includes('garanti')) return BANK_PROVIDERS.GARANTI;
  if (raw.includes('vakif')) return BANK_PROVIDERS.VAKIFBANK;
  return raw;
};

const LogoFrame = ({ meta, dims, sx = {} }) => (
  <Box
    sx={{
      width: dims.width,
      height: dims.height,
      minWidth: dims.width,
      minHeight: dims.height,
      borderRadius: `${LOGO_RADIUS}px`,
      overflow: 'hidden',
      flexShrink: 0,
      bgcolor: meta.frameBg || '#f8fafc',
      boxShadow: '0 2px 8px rgba(15,23,42,0.14)',
      border: '1px solid rgba(15,23,42,0.06)',
      ...sx,
    }}
  >
    <Box
      component="img"
      src={meta.assetSrc}
      alt={meta.label}
      sx={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: meta.objectPosition || 'center center',
        display: 'block',
      }}
    />
  </Box>
);

/**
 * Merkezi banka logosu — VakıfBank ve Garanti BBVA, aynı dikdörtgen çerçeve + cover kırpma.
 */
function BankLogo({ bank, bankLogoKey, size = 'sm', sx = {} }) {
  const key = resolveBankKey(bank, bankLogoKey);
  const meta = BANK_LOGO_META[key];
  const dims = SIZE_MAP[size] || SIZE_MAP.sm;

  if (!meta?.assetSrc) {
    return (
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: dims.width,
          height: dims.height,
          borderRadius: `${LOGO_RADIUS}px`,
          bgcolor: meta?.bg || '#94a3b8',
          color: '#fff',
          fontSize: 11,
          fontWeight: 900,
          letterSpacing: '0.02em',
          flexShrink: 0,
          ...sx,
        }}
      >
        {meta?.badge || '?'}
      </Box>
    );
  }

  return <LogoFrame meta={meta} dims={dims} sx={sx} />;
}

export default BankLogo;
